import config from "@shared/config/client";
import queryString from "query-string";
import buildFormData from "../helpers";
import { FeedPostImage } from "../posts/types";
import { ICallableRequestBuilder } from "../requestBuilder/types";
import { withAuthenticatedClientRequest } from "../requestBuilder/withClientRequest";
import { UploadResult } from "./types";

export async function uploadCollectionProfile(
  file: File,
): Promise<UploadResult> {
  const formData = buildFormData(file);

  const result = await fetch(`${config.apiUrl}/upload/collection`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });

  return await result.json();
}

export async function uploadCollectionCover(file: File): Promise<UploadResult> {
  const formData = buildFormData(file);

  const result = await fetch(`${config.apiUrl}/upload/collection-cover`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });

  return await result.json();
}

export async function uploadUserCover(file: File): Promise<UploadResult> {
  const formData = buildFormData(file);

  const result = await fetch(`${config.apiUrl}/upload/cover`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });

  return await result.json();
}

export async function uploadUserProfile(file: File): Promise<UploadResult> {
  const formData = buildFormData(file);

  const result = await fetch(`${config.apiUrl}/upload/profile`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });

  return await result.json();
}

export async function uploadPostImage(image: File): Promise<FeedPostImage> {
  const formData = buildFormData(image);

  const result = await fetch(`${config.apiUrl}/upload/post-image`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });

  const uploadResult: UploadResult = await result.json();

  return {
    imageUrl: uploadResult.fileUrl,
    imagePlaceholder: uploadResult.blurImage,
  };
}

export async function uploadArtOrder(image: File): Promise<UploadResult> {
  const formData = buildFormData(image);

  const result = await fetch(`${config.apiUrl}/upload/art-order`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });

  return await result.json();
}

const uploadAiGeneratedAudioGuide =
  (request: ICallableRequestBuilder<string>) =>
  (nftId: string, description: string) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/upload/audio-guide/ai/${nftId}`,
    });
    return request.call(url, (init) => ({
      ...init,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        description,
      }),
    }));
  };

const uploadAudioGuide =
  (request: ICallableRequestBuilder<string>) => (nftId: string, file: File) => {
    const formData = buildFormData(file);

    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/upload/audio-guide/upload/${nftId}`,
    });

    return request.call(url, (init) => ({
      ...init,
      method: "POST",
      body: formData,
    }));
  };

const clientRequests = {
  uploadAiGeneratedAudioGuide: withAuthenticatedClientRequest(
    uploadAiGeneratedAudioGuide,
  ),
  uploadAudioGuide: withAuthenticatedClientRequest(uploadAudioGuide),
};

export default clientRequests;
